import PropTypes from 'prop-types';
import React from 'react';
import { RaisedButton, Paper, List, ListItem } from 'material-ui';

const styles = {
  list: {
    margin: 8,
  },
  listEmpty: {
    margin: 8,
    padding: 8,
  },
};

class ClientsList extends React.Component {
  static propTypes = {
    clients: PropTypes.object,
    onChooseClient: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  getClient = (client) => {
    const { onChooseClient } = this.props;
    onChooseClient && onChooseClient(client);
  };

  createClient = () => {
    this.context.router.push('/clients/new');
  };

  render() {
    const { clients } = this.props;

    let renderedClients;
    if (window.location.pathname !== '/clients') {
      renderedClients = <div> </div>;
    } else {
      renderedClients = (
        <Paper style={styles.list}>
          <List>
            {clients && Object.keys(clients).map((ID) => {
              const client = clients[ID];

              return (
                <ListItem
                  key={client.id}
                  onClick={() => this.getClient(client)}
                  primaryText={client.name}
                  secondaryText={client.email}
                />
              );
            })}
          </List>
        </Paper>
      );
    }

    return (
      <div>
        {window.location.pathname !== '/clients/new' && (
          <div style={{ marginBottom: 15, marginLeft: 8 }}>
            <RaisedButton
              secondary
              label="Add Invoicing Client"
              onClick={this.createClient}
            />
          </div>
        )}
        {clients && Object.keys(clients).length !== 0 ? (
          renderedClients
        ) : (
          <Paper style={styles.listEmpty}>No clients found</Paper>
        )}
      </div>
    );
  }
}

export default ClientsList;
